<template>
    <div class="d-flex">
        <confirm-box ref="confirm"></confirm-box>
        <div class="d-flex align-items-center me-3">
            <button type="button" class="btn btn-secondary btn-sm me-1" @click="askRemove()"><i class="fa-solid fa-trash-can"></i></button>
            <admin-user-manage-status-button v-model="status" :id="id"></admin-user-manage-status-button>
            <button type="button" class="btn btn-secondary btn-sm" @click="edit()"><i class="fa-solid fa-pen-to-square"></i></button>
        </div>
        <div class="flex-grow-1">
            <h5 class="text-primary m-0">{{ name }}</h5>
            <h6 class="font-italic text-muted m-0">{{ email }}</h6>
            <h6 v-if="warnUser" class="mt-2 p-2 border border-warning rounded d-inline-block"><i class="fas fa-exclamation-circle me-2 text-warning"></i>User has no assigned districts</h6>
        </div>
        <div class="d-flex align-items-center">
            <span v-if="status == 5" class="badge bg-success"><i class="fas fa-user-shield me-2"></i>Super Admin</span>
            <span v-if="status == 4" class="badge bg-primary"><i class="fas fa-user-cog me-2"></i>Content Admin</span>
            <span v-if="status == 0" class="badge bg-secondary"><i class="fas fa-user-slash me-2"></i>Banned User</span>
        </div>
    </div>
</template>

<script>
import AdminUserManageStatusButton from './AdminUserManageStatusButton.vue';
import ConfirmBox from "./ConfirmBox";

export default {
    components: { AdminUserManageStatusButton, ConfirmBox },

    props: {
        value: {
            type: Object,
            default: function(data={}) {
                return data;
            }
        }
    },

    computed: {
        warnUser: function() {
            return Boolean(this.status == 1 && this.districts.length == 0);
        },
    },

    data() {
        return {
            districts: this.value.districts ?? [],
            email: this.value.email ?? '',
            id: this.value.id ?? -1,
            name: this.value.name ?? '',
            status: this.value.status ?? 1,
        }
    },

    methods: {
        askRemove: function() {
            this.$refs.confirm.show({
                title: 'Delete User',
                content: `Are you sure you would like to delete this user <b>${this.name}</b>?`,
                callback: () => this.remove(),
            });
        },

        edit: function() {
            this.$emit('edit', this.id);
        },

        remove: function() {
            this.$parent.isLoading = true;
            axios
                .delete(`/api/admin/users/${this.id}`)
                .then(response => {
                    //this.users = response.data;
                    this.$emit('delete', this.id);
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });
        },

    }
}
</script>

<style scoped>
.border-warning {
    background-color: lightyellow;
}
</style>